/*
 * @Author: $js
 * @Date: 2018-9-18 13:21:06
 * @Last Modified by: mikey.zhaopengy.zhaopeng
 * @Last Modified time: 2020-01-15 16:49:088
 */
// 公共服务


import axios from "axios";
import router from '@/router'


export default{
   install:function(Vue,opt){
    


     Vue.prototype.getDataInfo=function(mode, url, obj,tips,loading,message,userId) {


      return new Promise(function (resolve, reject) {

          //测试环境
          // var ipUrl = "https://testapi.growthideadata.com/order_book";
          var ipUrl = "https://api.growthideadata.com/goodidea_official_website";


          // 服务器正式环境
          // var ipUrl = "https://jiedexjihua.yili.com/order_book";
          
         
     
          
          axios.defaults.timeout = 6000000;
          // 请求头header
          // let token = getCookie("accessToken");

          // let token = getUserToken();
          // axios.defaults.headers["user_token"] = token;

          let config={}
          var qs = require("qs");
          axios.defaults.headers.terminal='H5';
      
          var mode1= mode ? mode :'get' 
          // console.log(qs.stringify(obj))
          // console.log(JSON.stringify(obj))
          switch (mode1) {
            case "put":
              config={
                method: 'put',
                url:ipUrl + url,
                data:qs.stringify(obj)
              }
              break;
            case "put2":
              config={    
                method: 'put',
                url:ipUrl + url,
                headers: {"Content-Type":"application/json;charset=UTF-8"},
                data:obj,
              }
              break;
            case "put3":
              config={    
                method: 'put',
                url:ipUrl + url,
                headers: {"Content-Type":"application/json;charset=UTF-8"},
                data:JSON.stringify(obj),
              }
              break;
            case "post":
              config={    
                method: 'post',
                url:ipUrl + url,
                headers: {"Content-Type":  'application/x-www-form-urlencoded'},
                data:obj
              }
              break;
            case "post2":
              config={    
                method: 'post',
                url:ipUrl + url,
                headers: {"Content-Type":"application/json;charset=UTF-8"},
                data:JSON.stringify(obj)
                // data:obj
              }
              break;
            case "post3":
              config={    
                method: 'post',
                url:ipUrl + url,
                headers: {"Content-Type":"application/json;charset=UTF-8"},
                data:obj,
              }
              break;
            case "post4":
              config={    
                method: 'post',
                url:ipUrl + url,
                headers: {"Content-Type":"application/json;charset=UTF-8"},
                data: obj
              }
              break;
            case "post5":
              config={    
                method: "post",
                url: ipUrl + url,
                headers: {
                  "Content-Type": "multipart/form-data"
                },
                data: obj
              }
              break;
              case "post6":
                config={    
                  method: "post",
                  url: ipUrl + url,
                  headers: {
                    headers: {"Content-Type":"application/json;charset=UTF-8"},
                  },
                  responseType: 'blob',
                  data: obj
                }
                break;
            case "patch":
              config={    
                method: "patch",
                url: ipUrl + url,
                data: qs.stringify(obj)
              }
              break;
            case "patch2":
              config={    
                method: 'patch',
                url:ipUrl + url,
                headers: {"Content-Type":"application/json;charset=UTF-8"},
                data:obj,
              }
              break;
            case "delete":
              config={    
                method: 'delete',
                url:ipUrl + url,
                params:obj,
              }
              break;
            case "delete2":
              config={    
                method: 'delete',
                url:ipUrl + url,
                headers: {"Content-Type":"application/json;charset=UTF-8"},
                data:obj,
              }
              break;
            case "get":
              config={    
                method: 'get',
                url:ipUrl + url,
                params:obj
              }
              break;
            case "get2":
              config={    
                method: 'get',
                url:ipUrl + url,
                headers: {"userId":userId},
                data:obj,
              }
              break;
          }
          
          axios(config).then(function (response) {
               

                if(response.data.code==200){
                  
                }
                else if(response.data.code==100101){
                  //token失效 跳转到登录页
                  // router.push("/login");
                  console.log("router666666", this.$router.history.current.fullPath);
                  let path = this.$router.history.current.fullPath;
                  // let pathIndex = this.$router.history.current.fullPath.indexOf("/", 1);
                  // let path = this.$router.history.current.fullPath.substr(0, pathIndex);


                }
                else{
                  
                }

                resolve(response)
        
          }).catch(function (error) {
            console.log("接口请求失败",error)

            let res={
                data:{
                  code:'-1'
                }
            }
            resolve(res)
          });
          
            
      })
     
    }


    // 获取user_token
    function getUserToken(){
      // console.log("this.$store.state:",store.state)
      return store.state.user_token
    }


    // ************************************************************************************************
    

    //设置Cookie
    function setCookie(c_name, value, expiredays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie =
        c_name +
        "=" +
        escape(value) +
        (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
    }

    //获取Cookie
    function getCookie(key) {
      var arr1 = document.cookie.split("; "); //由于cookie是通过一个分号+空格的形式串联起来的，所以这里需要先按分号空格截断,变成[name=Jack,pwd=123456,age=22]数组类型；
      for (var i = 0; i < arr1.length; i++) {
        var arr2 = arr1[i].split("="); //通过=截断，把name=Jack截断成[name,Jack]数组；
        if (arr2[0] == key) {
          return decodeURI(arr2[1]);
        }
      }
    }

    //清除Cookie
    function removeCookie(key) {
      setCookie(key, "", -1); //把cookie设置为过期
    }

    
    //设置localStorage
    Vue.prototype.setStorage=function (key, val, time) {
      localStorage.setItem(key, JSON.stringify(val));
    }

    //获取localStorage
    Vue.prototype.getStorage=function (key) {
      var json = localStorage.getItem(key);
      let dataObj = JSON.parse(json);
      if (dataObj) {
        if (dataObj.time) {
          let newDate = new Date().getTime();
          if (newDate - dataObj.time > 3000) {
            stoRemove(key);
          } else {
            return dataObj;
          }
        } else {
          return dataObj;
        }
      }
    }

    //删除localStorage某个key
    Vue.prototype.stoRemove=function (key) {
      localStorage.removeItem(key);
    }

    //清空localStorage
    Vue.prototype.stClear=function () {
      localStorage.clear();
    }


     //参数验证公共方法
     Vue.prototype.Verification=function (content,contentType,msg) {
       var  ver;
       let  msgg;

      //  console.log(contentType) 
      //  console.log(content) 
      //如果值不为空但有特殊验证需求（数字类型）
      if(!content && content !== 0 && !contentType){
        console.log(1)
        //判断值是否为数字
        ver =content ? content : false
        msgg= msg ? msg : '请认真填写必填项'
      }
      // 验证是否为数字
       else   if(contentType=='number'){
        console.log(3)
         //判断值是否为数字
         ver = ! isNaN(Number(content))
         msgg=msg ? msg : '非数字格式'
       }
       //如果值不为空但有特殊验证需求（电话号码）
       else if(contentType=="Phone"){
        console.log(2)
         var reg=/^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
         //验证是否为电话号码
         ver =reg.test(content)
      
         msgg='请输入正确的电话号码'
       }
       //如果值不为空但有特殊验证需求（手机号码）
       else if(contentType =="mobilePhone"){
         console.log(4)
         var reg=/^1[3|4|5|7|8][0-9]{9}$/;
         //验证是否为电话号码
         ver =reg.test(content)
         msgg= msg ? msg : '请输入正确的手机号码'
       }
       //验证开头不为0的正整数
       else if(contentType =="iSnumber"){
        console.log(5)
         var reg=/^[1-9][0-9]*$/;
         ver =reg.test(content)
         msgg= msg ? msg : '开头不能为0的正整数'
       }
       //如果值不为空但有特殊验证需求（保留两位小数）
       else if(contentType =="Decimal"){
        console.log(6)
         var reg=/^[0-9]+(.[0-9]{1,2})?$/;
         ver =reg.test(content)
         msgg= msg ? msg : '数字格式不正确，保留两位小数'
       }
       //如果值不为空但有特殊验证需求（大于0保留两位小数）
       else if(contentType =="DYLDecimal"){
        console.log(7)
         var reg=/^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,12}\.\d{0,2}$|^[1-9]\d{0,8}$/;
         ver =reg.test(content)
         msgg= msg ? msg : '数字格式不正确，大于0，保留两位小数'
       }
       //如果值不为空那么只能输入正数（保留两位小数）
       else if(contentType =="neDecimal"){
        console.log(8)
         var reg=/^[0-9]+(.[0-9]{1,2})?$/;
         ver =reg.test(content)
         msgg= msg ? msg : '数字格式不正确，正数保留两位小数'
       }
       //如果值不为空但有特殊验证需求（6-16位密码）
       else if(contentType =="password_8_16"){
        console.log(9)
         //验证6-16位字母数字密码
         var reg=/^[a-zA-Z0-9]{8,16}$/;
         ver =reg.test(content)
         msgg= msg ? msg : '请输入6-16位密码'
       }
      //  
      else if(contentType == "pointTypeReg"){
        var reg = /^[A-Z]{1,}[1-9]{2}[A-Z]{2,3}[1-9][A-Z]{0,1}([1-9][0-9]{0,1})?S|Z|X|D|J$/;
        ver =reg.test(content)
        msgg= msg ? msg : '监控点位类型格式不正确'
      }
       //如果值不为空但有特殊验证需求（身份证号）
       else if(contentType == "idcard"){
        console.log(10)
         //验证身份证
         var reg=/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
         ver =reg.test(content)
         msgg= msg ? msg : '请输入正确的身份证号'
       }
       //如果值不为空但有特殊验证需求（座机号）
       else if(contentType == 'landline'){
        console.log(11)
         //验证座机
         var reg=/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
         ver =reg.test(content)
         msgg= msg ? msg : '请输入正确的座机号'
       }
       //如果值不为空但有特殊验证需求（正整数）
       else if(contentType =="integer"){
        console.log(12)
         //验证正整数
         var reg=/^\+?[1-9][0-9]*$/;
         ver =reg.test(content)
         msgg= msg ? msg : '数字必须为正整数'
       }
       //如果值不为空但有特殊验证需求（非负整数）
       else if(contentType =="netInteger"){

         //验证正整数
         var reg=/^\d+$/;
         ver =reg.test(content)
         msgg= msg ? msg : '非负整数'
       }
       //如果值不为空但有特殊验证需求（邮箱）
       else if(contentType =="email"){
        console.log(14)
         //验证邮箱
         var reg=/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
         ver =reg.test(content)
         msgg= msg ? msg : '请输入正确的邮箱'
       }
       //如果值不为空但有特殊验证需求（0-100保留两位小数）
       else if(contentType =="Decimal_0_100"){
         var reg=/^[0-9]+(.[0-9]{1,2})?$/;
         if(reg.test(content)&&content>=0&&attrs.content<=100){
           ver =true
         }else{
           ver =false
           msgg= msg ? msg : '0-100保留两位小数'
         };
       }
       //如果值不为空但有特殊验证需求回调函数
       else{
          ver= true;
       }
      
       if(!ver){
       }
       return  ver
     }



//结束
   }
}



// WEBPACK FOOTER //
// ./src/utils/services.js